<template>
    <div style="background: #f7f8fa">
        <van-nav-bar
                title="创建提货配车"
                left-text=""
                right-text=""
                left-arrow
                fixed
                @click-left="back()"
                @click-right="searchPop()"
                v-if="show"
        />


        <div class="contentwarp">
            <van-pull-refresh v-model="isLoading" @refresh="onRefresh"  >
                <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text=""
                        @load="onLoad"
                        style="margin-bottom: 10px"
                >
                    <van-cell   >
                        <van-row gutter="20">
                            <van-col span="20"><span class="detailLabel detailtitle">车辆信息</span></van-col>
                            <van-col span="4" ><a type="info" style="color:#6685a4;" @click="add()">添加<van-icon name="plus" /></a></van-col>
                        </van-row>
                    </van-cell>
                    <van-swipe-cell v-for="item in listPer" :key="item.deliveryTruckId" class="swipewarp">
                        <van-cell   >
                            <van-row gutter="20">
                                <van-col span="7">{{item.truckNo}}</van-col>
                                <van-col span="7" style="text-align: center">{{item.driverName}}</van-col>
                                <van-col span="10" style="text-align: right">{{item.driverPhoneNumber}}</van-col>
<!--                                <van-col span="2"><van-icon name="arrow" /></van-col>-->
                            </van-row>
                        </van-cell>
                        <template #right>
                            <van-button plain  type="danger" text="移除" style="background-color:#6685a4;color:white" @click="remove(item.deliveryTruckId)"/>
                        </template>
                    </van-swipe-cell>

                </van-list>
                <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="onLoad"
                >
                    <van-cell   >
                        <van-row gutter="20">
                            <van-col span="20"><span class="detailLabel detailtitle">提单信息</span></van-col>
                            <van-col span="4" style="color:#6685a4" @click="roadList()">刷新<van-icon name="replay" style=""/></van-col>

                        </van-row>
                    </van-cell>
                    <van-swipe-cell v-for="item in list" :key="item.outnotifyId" class="swipewarp" right-width="60">
                        <van-cell   >
                            <van-row gutter="20">
                                <van-col span="12">{{item.outnotifyNo}}</van-col>
                                <van-col span="12" style="text-align: right">
                                    <span v-if="showStatus(item)=='done'">完结</span>
                                    <span v-else-if="showStatus(item)=='unpay'">{{item.balanceAmount}}元 <a style="color:#6685a4;margin-left: 10px">去支付</a></span>
                                    <span v-else-if="showStatus(item)=='pay'">审核</span>
                                </van-col>
                            </van-row>
                            <van-row gutter="20">
                                <van-col span="24">
                                    <van-row gutter="20">
                                        <van-col span="10" style="color: #727272;word-break:keep-all;white-space:nowrap;">{{item.customerName}}</van-col>
                                        <van-col span="14" style="color: #727272;text-align: right">{{item.outnotifyCustomerNo}}</van-col>
                                    </van-row>
                                    <van-row gutter="20"  v-for="cargoitem in item.cargo" :key="cargoitem.cargoName">
                                        <van-col span="10" style="color: #727272">{{cargoitem.cargoName}}</van-col>
                                        <van-col span="14" style="color: #727272;text-align: right">{{cargoitem.amount}}件，{{cargoitem.weight}}吨</van-col>
                                    </van-row>
                                </van-col>
<!--                                <van-col span="2" style="line-height: 48px"><van-icon name="arrow" /></van-col>-->
                            </van-row>


                        </van-cell>
                        <template #right>
                            <van-button plain  type="danger" style="height:100px;width:60px;background-color:#6685a4;color:white " text="移除" @click="removedetail(item.outnotifyId)"/>
                        </template>
                    </van-swipe-cell>

                </van-list>
            </van-pull-refresh>
        </div>

        <van-popup v-model="showpop" position="right" :style="{ height: '100%', width:'80%'}" >
            <van-nav-bar
                    title="添加车辆"
                    fixed
            />
            <div class="editwarp">
                <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text=""
                        @load="onLoad"
                >
                    <van-checkbox-group v-model="result" ref="checkboxGroup">
                        <van-cell   v-for="item in listPersel" :key="item.deliveryTruckId" class="swipewarp" style="padding: 15px 8px">
                            <van-row gutter="20">
                                <van-col span="3" style="padding-right: 0"> <van-checkbox :name=item.deliveryTruckId></van-checkbox></van-col>
                                <van-col span="6" style="padding-right: 0">{{item.truckNo}}</van-col>
                                <van-col span="6" style="padding-right: 0">{{item.driverName}}</van-col>
                                <van-col span="9" style="padding-left: 8px">{{item.driverPhoneNumber}}</van-col>
                            </van-row>
                        </van-cell>
                    </van-checkbox-group>

                </van-list>
                <van-button  block size="small" type="info" native-type="submit" style="font-size: 16px;margin: 10px auto;width: 100px" @click="savePerson()">
                    确定
                </van-button>
            </div>
        </van-popup>

        <van-button class="closebutton" type="info" native-type="submit" style="font-size: 16px;" @click="saveOut()">
            确认提交
        </van-button>
    </div>
</template>

<script>
    import {NavBar, Toast, Cell, Button, Icon, Field, Dialog,Checkbox, CheckboxGroup} from 'vant';
    import {List } from 'vant';
    import {Search  } from 'vant';
    import { Col, Row } from 'vant';
    import {SwipeCell } from 'vant';
    import {Popup } from 'vant';
    import {PullRefresh } from 'vant';
    import {Sticky } from 'vant';
    import { RadioGroup, Radio } from 'vant';
    import { Calendar } from 'vant';
    import service from '../../server/index'

    export default {
        name: "AddOut",
        components: {
            [NavBar.name]: NavBar,
            [Search.name]: Search,
            [List.name]: List,
            [Col.name]: Col,
            [Row .name]: Row ,
            [Cell.name]: Cell,
            [SwipeCell.name ]:SwipeCell,
            [Button.name]:Button,
            [Popup.name]: Popup,
            [Icon.name]:Icon,
            [Field.name]:Field,
            [PullRefresh.name]: PullRefresh,
            [Sticky.name]: Sticky,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]:Radio,
            [Calendar.name]:Calendar,
            [Checkbox.name]:Checkbox,
            [CheckboxGroup.name]:CheckboxGroup
        },
        computed:{
            showStatus(){
                return function(item){
                    if(item.status=="30"){
                        return "done";
                    }else{
                        if(item.balanceStatus=="0"){
                            return "unpay";
                        }else{
                            return "pay"
                        }
                    }
                }
            }
        },
        data(){
            return {
                value:"",
                show:true,//nav bar
                result:[],
                listPer: [],
                listPersel: [],
                list: [],
                loading:true,
                finished: false,
                showpop:false,
                ouid:"",
                searchValue:{
                    keywords:"",
                    startDate:"",
                    endDate:"",
                    status:20,
                    deliveryName:this.$store.username,
                    deliveryIdnumber:this.$store.deliveryIdnumber
                },
                searchShowPop:false,
                //编辑
                info:{
                    "outnotifyNo":"",
                    "balanceAmount":"",
                    "customerName":"",
                    "outnotifyCustomerNo":"",
                    "status":"",
                    "balanceStatus":"",
                    "cargo":[
                        {
                            "cargoName":"",
                            "amount":"",
                            "weight":""
                        }
                    ]
                },
                //刷新
                isLoading:false,
                page:1,
                //日期选择calendarShow
                calendarShow:false

            }
        },
        mounted() {
            this.onLoad();
            this.selPerson();
        },
        methods:{
            back(){
                this.$router.replace("/Home/MyOut")
            },
            roadList(){
                this.list = [];
                this.page = 1;
                this.onLoad();
            },
            savePerson(){
                let newArr=new Array
                for(let item of this.listPersel)
                {
                    if(this.result.indexOf(item.deliveryTruckId)>=0)
                    {
                        newArr.push(item)
                    }
                }
                this.listPer=newArr
                this.showpop=false
            },
            onSearch(){
                this.list = [];
                this.page = 1;
                this.onLoad();
            },
            selPerson()
            {

                let param = {
                    query:"",
                    userId:localStorage.getItem("userId"),
                }
                service.getTruckList(param).then((res)=>{
                    if(res.code=="200"){
                        this.listPersel=res.data
                    }else{

                        Toast(res.msg)
                    }

                }).catch((res)=>{

                    Toast(res.msg)
                });

            },
            onLoad(){

                let param = {
                    keywords:this.searchValue.keywords,
                    startDate:this.searchValue.startDate,
                    endDate:this.searchValue.endDate,
                    status:this.searchValue.status,
                    deliveryName:localStorage.getItem("personName"),
                    deliveryIdnumber:localStorage.getItem("deliveryIdnumber"),
                    limit:10,
                    page:this.page
                }
                service.ladingBillList(param).then((res)=>{
                    if(res.code=="200"){

                        if(res.data.length>0){
                            for (let i = 0; i < res.data.length; i++) {
                                if(i==0)
                                {
                                 this.ouid=res.data[0].ouid
                                }
                                this.list.push(res.data[i]);
                            }
                            this.page++
                        }else{
                            this.finished = true;
                        }
                        // 加载状态结束
                        this.loading = false;
                        this.isLoading=false;
                    }else{
                        this.loading = false;
                        this.finished = true;
                        this.isLoading=false;
                        Toast(res.msg)
                    }

                }).catch((res)=>{
                    this.loading = false;
                    this.finished = true;
                    Toast(res.msg)
                });
            },
            searchPop(){
                this.searchValue= {keywords:"", from:"", to:"", status:"0"};
                this.searchShowPop = true;
            },
            editFleet(item){
                this.info={"id":item.id, "carNum":item.carNum, "dirver":item.dirver, "phone":item.phone}
                this.showpop = true;
            },
            saveFleet(){
                if(this.info.carNum==""){
                    Toast("请输入车牌号码")
                    return false;
                }

                if(this.info.dirver==""){
                    Toast("请输入驾驶员姓名")
                    return false;
                }
                if(this.info.phone==""){
                    Toast("请输入驾驶员手机号码")
                    return false;
                }

                if(this.info.id==""){
                    let param = {
                        "deliveryTruckId":"",
                        "truckNo": this.info.carNum,
                        "driverName":this.info.dirver,
                        "driverPhoneNumber":this.info.phone,
                        "deliveryId":localStorage.getItem("deliveryId"),
                        "userId":localStorage.getItem("userId"),
                    }
                    service.insertTruck(param).then((res)=>{
                        if(res.code=="200"){
                            this.showpop = false;
                            this.page = 1;
                            this.list = [];
                            this.onLoad();
                        }else{
                            Toast(res.msg)
                        }

                    }).catch((res)=>{
                        Toast(res.msg)
                    });
                }else{
                    let param = {
                        "deliveryTruckId":this.info.id,
                        "truckNo": this.info.carNum,
                        "driverName":this.info.dirver,
                        "driverPhoneNumber":this.info.phone,
                        "deliveryId":localStorage.getItem("deliveryId"),
                        "userId":localStorage.getItem("userId"),
                    }
                    service.updateTruck(param).then((res)=>{
                        if(res.code=="200"){
                            this.showpop = false;
                            this.page = 1;
                            this.list = [];
                            this.onLoad();
                        }else{
                            Toast(res.msg)
                        }

                    }).catch((res)=>{
                        Toast(res.msg)
                    });
                }
            },
            onRefresh(){
                this.onLoad();

            },
            saveOut(){

                let zhuTruck=[]
                let detailTruck=[]

                for (let item of this.listPer)
                {
                    let o={}
                    o.truckNo=item.truckNo
                    o.driverPhonenumber=item.driverPhoneNumber
                    o.driverName=item.driverName
                    o.createPersonId=localStorage.getItem("personId")
                    o.status=10
                    o.proveMode=10
                    zhuTruck.push(o)

                }

                for (let item of this.list)
                {
                    let o={}
                    o.outnotifyId=item.outnotifyId
                    o.outnotifyNo=item.outnotifyNo
                    o.outnotifyCustomerNo=item.outnotifyCustomerNo
                    o.businessType=30
                    detailTruck.push(o)

                }

                let param = {
                    truckprove:zhuTruck,
                    truckprovenotify:detailTruck,
                    status:20,
                    ouid: this.ouid
                }
                if(zhuTruck.length==0)
                {
                    Toast("请添加驾驶员")
                    return
                }
                if(detailTruck.length==0)
                {
                    Toast("无有效提单")
                    return
                }
                service.addOutTruk(param).then((res)=>{
                    if(res.code=="200"){
                        Toast("保存成功")
                        this.$router.replace("/Home/MyOut")
                    }else{

                        Toast("保存失败："+res.msg)

                    }

                }).catch((res)=>{
                    Toast("保存失败："+res.msg)
                });
            },
            add(){
                this.showpop=true;
            },
            removedetail(id){
                Dialog.confirm({
                    title: '提示消息',
                    message: '确定移除该提单吗？',
                    confirmButtonColor:"#6685a4"
                })
                    .then(() => {
                        let newArr=[]

                        for(let item of this.list)
                        {
                            if(item.outnotifyId != id)
                            {

                                newArr.push(item)
                            }

                        }
                        this.list=newArr


                    })
                    .catch(() => {
                        // on cancel
                    });
            },
            remove(id){
                Dialog.confirm({
                    title: '提示消息',
                    message: '确定移除该车辆吗？',
                    confirmButtonColor:"#6685a4"
                })
                    .then(() => {
                        let newArr=[]
                        for(let item of this.listPer)
                        {
                            if(item.deliveryTruckId != id)
                            {

                                newArr.push(item)
                            }

                        }
                        this.listPer=newArr


                    })
                    .catch(() => {
                        // on cancel
                    });
            },
            //日期组件
            formatDate(date) {
                return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
            },
            calendarConfirm(date){
                const [start, end] = date;
                this.calendarShow = false;
                this.searchValue.from = `${this.formatDate(start)} - ${this.formatDate(end)}`;
            },
            resetSearch(){
                this.searchValue= {keywords:"", from:"", to:"", status:"0"};
            }
        }
    }
</script>

<style scoped>
    .van-popup{
        background-color: #f7f8fa;
    }

    .searchwarp{
        margin-top: 40px;
    }
    .editwarp{
        width:100%;
        margin: 46px auto;
    }

    /*.swipewarp{*/
    /*    height: 100px;*/
    /*}*/

    .contentwarp{
        margin-top:46px;
        height: calc(100vh - 100px);
    }
    .detailLabel.detailtitle{
        color: #323233;
        font-weight: bold;
    }
    /*/deep/ .van-ellipsis{*/
    /*    color: #EE0A24;*/
    /*}*/
    /*/deep/ .van-nav-bar .van-icon{*/
    /*    color: #EE0A24;*/
    /*}*/

    /*/deep/ .van-nav-bar__text{*/
    /*    color: #EE0A24;*/
    /*}*/
    /deep/ .van-nav-bar .van-icon,
    /deep/ .van-nav-bar__text ,
    /deep/ .van-calendar__day--middle,
    van-icon.van-icon-arrow{
        color: #6685a4 ;
    }
    /deep/ .van-button--info ,
    /deep/ .van-button--danger{
        /*background-color: #6685a4 ;*/
        /*border: 1px solid #6685a4 ;*/
        background-color: white;
        border: 1px solid white;
        color:#6685a4;

    }

    .van-icon.van-icon-success,
    /deep/ .van-checkbox__icon--checked .van-icon{
        background-color: #6685a4 ;
        border: 1px solid #6685a4 ;
    }
    .van-button--plain.van-button--danger {
        color: #6685a4;
    }
    /deep/ .van-checkbox{
        padding-left: 8px;
    }
    .closebutton{
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0px;
        height: 50px;
        width: 100% !important;
        margin:auto;
    }
</style>